module.exports = __webpack_public_path__ + "static/media/ld.b879ae6f.jpeg";